import { startPage } from '../main';
import { html, raw } from '../lib/html';
import { icons } from '../lib/icons';

/** The tutorial videos on Patternade's YouTube channel, in order. */
export const VIDEOS = [
  { id: 'iTuxgfTlpsw', title: 'Getting started' },
  { id: 'wYE3gtoUH6Y', title: 'Navigating the workspace' },
  { id: 'HIPV7VKEPY0', title: 'Using rulers and guides' },
  { id: '1z9grBND5IQ', title: 'Modifying the shape of lines' },
  { id: 'jnyaB0Dc01Q', title: 'Mirror pieces and consolidate' },
  { id: 'KlMjrsLMG4U', title: 'Creating darts' },
  { id: 'vf127cUMUZ4', title: 'Cutting and joining' },
  { id: 'nVM-6IAQ-4A', title: 'Parallel extend of a line' },
  { id: 'bDLhARRupzU', title: 'Adding notches and drill holes' },
  { id: 'UTXj8sW2upM', title: 'Walking pieces' },
  { id: '33GOW7cCasQ', title: 'Applying seam allowances' },
  { id: 'pOnPAIe_7pM', title: 'Pattern grading' },
  { id: 'p14-2UpG_Uw', title: 'Adding text and arrows' },
  { id: 'G1LtC9WIRn8', title: 'Printing a pattern at home' },
  { id: 'LwMWITgPIUg', title: 'Exporting your pattern' },
];

startPage();

const current = new URLSearchParams(window.location.search).get('v');
const index = VIDEOS.findIndex((video) => video.id === current);
const href = (video) => `/tutorials/?v=${encodeURIComponent(video.id)}`;

document.getElementById('tutorial-menu').innerHTML = VIDEOS.map((video, i) => (i === index
  ? html`<li class="font-semibold text-pink" aria-current="page">${video.title}</li>`
  : html`<li><a href="${href(video)}" class="hover:text-pink">${video.title}</a></li>`)).join('');

document.getElementById('tutorial-grid').innerHTML = VIDEOS.map((video) => html`<li>
  <a href="${href(video)}" class="group block">
    <span class="relative block overflow-hidden rounded-lg">
      <img src="https://img.youtube.com/vi/${video.id}/mqdefault.jpg" alt="" loading="lazy" class="w-full" />
      <span class="absolute inset-0 flex items-center justify-center bg-black/20 text-white opacity-80 transition group-hover:bg-black/40 group-hover:opacity-100">${raw(icons.play({ size: 'h-10 w-10' }))}</span>
    </span>
    <span class="mt-2 block text-center text-sm font-medium group-hover:text-pink">${video.title}</span>
  </a>
</li>`).join('');

if (index !== -1) {
  const video = VIDEOS[index];
  document.title = `${video.title} | Patternade tutorials`;
  document.getElementById('tutorial-intro').hidden = true;
  document.getElementById('tutorial-player').hidden = false;
  document.getElementById('tutorial-title').textContent = video.title;
  document.getElementById('tutorial-video').src = `https://www.youtube-nocookie.com/embed/${video.id}?autoplay=1&rel=0`;

  const prev = VIDEOS[index - 1];
  const next = VIDEOS[index + 1];
  const prevLink = document.getElementById('tutorial-prev');
  const nextLink = document.getElementById('tutorial-next');
  if (prev) { prevLink.href = href(prev); prevLink.textContent = `← ${prev.title}`; }
  if (next) { nextLink.href = href(next); nextLink.textContent = `${next.title} →`; }
}
